// The 20 questions — exact text and trait deltas, verbatim per spec.
export const QUESTIONS = [
  {
    id: 1,
    text: "Someone insults you in front of everyone.",
    options: [
      { text: "I fire back — sharper and wittier.", deltas: { AMB: 2, RES: 1 } },
      { text: "I stay calm. It says more about them than me.", deltas: { SER: 3, DIS: 1 } },
      { text: "I ask them why they think that.", deltas: { CUR: 3, EMP: 1 } },
      { text: "I walk away. My peace is worth more.", deltas: { SER: 2, RES: 1 } },
    ],
  },
  {
    id: 2,
    text: "A project you truly cared about fails.",
    options: [
      { text: "I start again the next morning.", deltas: { RES: 3, DIS: 1 } },
      { text: "I dissect exactly what went wrong.", deltas: { CUR: 2, DIS: 2 } },
      { text: "I let myself feel it — then let it go.", deltas: { EMP: 2, SER: 2 } },
      { text: "I aim at something even bigger.", deltas: { AMB: 3 } },
    ],
  },
  {
    id: 3,
    text: "You win ten million euros.",
    options: [
      { text: "Travel. See everything.", deltas: { CUR: 2, SER: 1 } },
      { text: "Build something ambitious with it.", deltas: { AMB: 3, DIS: 1 } },
      { text: "Change almost nothing about my life.", deltas: { SER: 3, DIS: 1 } },
      { text: "Give a large part of it away.", deltas: { EMP: 3 } },
    ],
  },
  {
    id: 4,
    text: "A completely free day. No obligations.",
    options: [
      { text: "Read. Learn something new.", deltas: { CUR: 3 } },
      { text: "Train. Push my body.", deltas: { DIS: 2, RES: 1 } },
      { text: "Spend it with people I love.", deltas: { EMP: 2, SER: 1 } },
      { text: "Work on my own project.", deltas: { AMB: 2, DIS: 2 } },
    ],
  },
  {
    id: 5,
    text: "A friend is about to make a big mistake.",
    options: [
      { text: "I tell them straight, even if it stings.", deltas: { RES: 1, AMB: 1, DIS: 1 } },
      { text: "I ask questions until they see it themselves.", deltas: { CUR: 2, EMP: 1 } },
      { text: "I support them no matter what they choose.", deltas: { EMP: 3 } },
      { text: "Their life, their lesson.", deltas: { SER: 2 } },
    ],
  },
  {
    id: 6,
    text: "What bothers you the most?",
    options: [
      { text: "Wasted potential.", deltas: { AMB: 3 } },
      { text: "Injustice.", deltas: { EMP: 3 } },
      { text: "People who refuse to think.", deltas: { CUR: 3 } },
      { text: "Losing control of myself.", deltas: { DIS: 2, SER: 1 } },
    ],
  },
  {
    id: 7,
    text: "A brutal deadline is coming.",
    options: [
      { text: "Cut everything out. Grind.", deltas: { DIS: 3 } },
      { text: "Good. I'm at my best under pressure.", deltas: { RES: 2, AMB: 1 } },
      { text: "Steady pace, real breaks. Panic helps no one.", deltas: { SER: 2, DIS: 1 } },
      { text: "First question: does this deadline even matter?", deltas: { CUR: 1, SER: 2 } },
    ],
  },
  {
    id: 8,
    text: "How do you relate to death?",
    options: [
      { text: "It's why I move fast.", deltas: { AMB: 2, RES: 1 } },
      { text: "It's natural. I've made peace with it.", deltas: { SER: 3 } },
      { text: "I think about it more than I admit.", deltas: { CUR: 2, SER: 1 } },
      { text: "I mostly think of the people I'd leave behind.", deltas: { EMP: 2, SER: 1 } },
    ],
  },
  {
    id: 9,
    text: "A rule exists that you find absurd.",
    options: [
      { text: "I follow it while working to change it.", deltas: { DIS: 2, EMP: 1 } },
      { text: "I break it. Openly.", deltas: { RES: 2, AMB: 1 } },
      { text: "First I want to know why it exists.", deltas: { CUR: 3 } },
      { text: "I quietly ignore it and move on.", deltas: { SER: 2 } },
    ],
  },
  {
    id: 10,
    text: "A good life is mostly...",
    options: [
      { text: "Leaving a mark on the world.", deltas: { AMB: 3 } },
      { text: "Peace of mind.", deltas: { SER: 3 } },
      { text: "Understanding how things really work.", deltas: { CUR: 3 } },
      { text: "Deep bonds with other people.", deltas: { EMP: 3 } },
    ],
  },
  {
    id: 11,
    text: "Someone harshly criticizes your work.",
    options: [
      { text: "I hunt for the truth hidden in it.", deltas: { CUR: 2, DIS: 1 } },
      { text: "It doesn't shake me either way.", deltas: { RES: 2, SER: 1 } },
      { text: "It stings — and I thank them anyway.", deltas: { EMP: 2, DIS: 1 } },
      { text: "I'll prove them wrong.", deltas: { AMB: 2, RES: 1 } },
    ],
  },
  {
    id: 12,
    text: "Cold showers, hard hikes, discomfort.",
    options: [
      { text: "I seek it out. It forges me.", deltas: { RES: 3, DIS: 1 } },
      { text: "I endure it when it's useful.", deltas: { DIS: 2, RES: 1 } },
      { text: "I avoid it. Comfort is not a crime.", deltas: { SER: 2, EMP: 1 } },
      { text: "Honestly? I barely notice it.", deltas: { RES: 2, SER: 1 } },
    ],
  },
  {
    id: 13,
    text: "In a group, you naturally...",
    options: [
      { text: "Take charge.", deltas: { AMB: 2, DIS: 1 } },
      { text: "Ask the question nobody dares to ask.", deltas: { CUR: 2, RES: 1 } },
      { text: "Hold everyone together.", deltas: { EMP: 3 } },
      { text: "Do your part, reliably, without noise.", deltas: { DIS: 2, SER: 1 } },
    ],
  },
  {
    id: 14,
    text: "Your relationship with social media:",
    options: [
      { text: "A tool. I use it deliberately.", deltas: { DIS: 2, SER: 1 } },
      { text: "A stage for ideas worth spreading.", deltas: { AMB: 2, CUR: 1 } },
      { text: "Mostly noise. I stay away.", deltas: { SER: 2, CUR: 1 } },
      { text: "How I stay close to people I love.", deltas: { EMP: 2 } },
    ],
  },
  {
    id: 15,
    text: "Mid-argument, you realize you're wrong.",
    options: [
      { text: "I admit it on the spot.", deltas: { CUR: 2, DIS: 1 } },
      { text: "I concede gently, saving face for everyone.", deltas: { EMP: 2, SER: 1 } },
      { text: "I keep arguing — for sport.", deltas: { AMB: 1, RES: 2 } },
      { text: "I laugh at myself out loud.", deltas: { SER: 2, RES: 1 } },
    ],
  },
  {
    id: 16,
    text: "Possessions:",
    options: [
      { text: "Own little. Need less.", deltas: { SER: 2, RES: 1 } },
      { text: "Comfort is fine. Excess is a trap.", deltas: { SER: 2, DIS: 1 } },
      { text: "I want to earn great things.", deltas: { AMB: 2, DIS: 1 } },
      { text: "What I have is for sharing.", deltas: { EMP: 2, SER: 1 } },
    ],
  },
  {
    id: 17,
    text: "Your deepest fear:",
    options: [
      { text: "A meaningless life.", deltas: { AMB: 2, CUR: 1 } },
      { text: "Hurting the people I love.", deltas: { EMP: 3 } },
      { text: "Losing my freedom.", deltas: { RES: 2, SER: 1 } },
      { text: "Dying without understanding anything.", deltas: { CUR: 3 } },
    ],
  },
  {
    id: 18,
    text: "Your mornings:",
    options: [
      { text: "A routine. Non-negotiable.", deltas: { DIS: 3 } },
      { text: "Depends on the day — and that's fine.", deltas: { SER: 2, CUR: 1 } },
      { text: "Straight into the hardest problem.", deltas: { AMB: 2, RES: 1 } },
      { text: "Slow. Coffee, thoughts, the people around me.", deltas: { EMP: 1, SER: 2 } },
    ],
  },
  {
    id: 19,
    text: "Advice to your younger self:",
    options: [
      { text: "The suffering will teach you. Let it.", deltas: { RES: 3 } },
      { text: "Question everything. Sooner.", deltas: { CUR: 2, RES: 1 } },
      { text: "Be kinder to yourself.", deltas: { EMP: 2, SER: 1 } },
      { text: "Start earlier. Aim higher.", deltas: { AMB: 2, DIS: 1 } },
    ],
  },
  {
    id: 20,
    text: "What should your tombstone say?",
    options: [
      { text: '"They never stopped asking why."', deltas: { CUR: 3 } },
      { text: '"Nothing could break them."', deltas: { RES: 3 } },
      { text: '"They loved well."', deltas: { EMP: 3 } },
      { text: '"They built something that outlived them."', deltas: { AMB: 2, DIS: 1 } },
    ],
  },
];
